import Vue from 'vue';
import VueMq from 'vue-mq';

import App from './layouts/App.vue';
import router from './router';
import store from './store';
import {
  schoolgidsUrl,
  inspectierapportUrl,
  bestuurUrl,
  schoolUrl,
  scholenoverzichtUrl,
  uploadsUrl,
  jaarverslagUrl,
} from './library/url-helpers';

import { toKM } from './views/ScholenzoekerMbo/filters';

Vue.config.productionTip = false;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
Vue.filter('schoolUrl', schoolUrl);
Vue.filter('schoolgidsUrl', schoolgidsUrl);
Vue.filter('uploadsUrl', uploadsUrl); // url voor codeigniter uploads (hardcoded link naar prod versie)

// jaarverslagen are scattered :(
// currently partly on the api server and partly on the wordpress server
Vue.filter('jaarverslagUrl', jaarverslagUrl);

Vue.filter('phonenumber', (number: string) => formatPhone(number));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
Vue.filter('time', (time: any) => {
  if (!time) { return null; }
  const splitTime = time.split(':');
  if (splitTime.length === 1) {
    return time;
  }
  return `${splitTime[0]}:${splitTime[1]}`;
});

Vue.filter('day', (dateStr: string) => {
  const date = new Date(dateStr);
  return date.toLocaleString('default', {
    day: '2-digit',
  });
});

Vue.filter('monthStr', (dateStr: string) => {
  const date = new Date(dateStr);
  return date.toLocaleString('default', {
    month: 'short',
  });
});

Vue.filter('weekday', (dateStr: string) => {
  const date = new Date(dateStr);
  return date.toLocaleString('default', {
    weekday: 'short',
  });
});

Vue.filter('year', (dateStr: string) => {
  const date = new Date(dateStr);
  return date.toLocaleString('default', {
    year: 'numeric',
  });
});

Vue.filter('retartedDate', (normalDate: string) => {
  let delim = '/';
  if (normalDate.split('/').length !== 3) {
    delim = '-';
  }

  const dateParts = normalDate.split(delim);
  if (dateParts.length !== 3) {
    console.log('Error unexpected normal date', normalDate, dateParts);
    return normalDate;
  }
  return `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;
});

Vue.filter('schoolgidsUrl', schoolgidsUrl);
Vue.filter('inspectierapportUrl', inspectierapportUrl);
Vue.filter('bestuurUrl', bestuurUrl);
Vue.filter('scholenoverzichtUrl', scholenoverzichtUrl);

function formatPhone(phone: string) {
  if (!phone) { return null; }

  let formattedPhone = '';
  for (let i = 0; i < phone.length; i += 1) {
    if (Number.isNaN(+phone[i])) {
      continue;
    }
    formattedPhone += phone[i];
    if (formattedPhone.length === 6 || formattedPhone.length === 9) {
      formattedPhone += ' ';
    }
  }
  formattedPhone = formattedPhone.replace(/^020/, '(020) ');
  return formattedPhone;
}

// mbo scholenzoeker bits
Vue.use(VueMq, {
  breakpoints: {
    mobile: 450,
    tablet: 900,
    laptop: 1250,
    desktop: Infinity,
  },
});
Vue.filter('toKM', toKM);

// global application state - this is an external dependency that is incomming
// these variables are used (a bit sloppy) to indicate that the external
// google lib is loaded and can be used.
(window as any).AppSettings = {
  googleLoaded: false,
};

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
